import {
  SupplierGetResponseType,
  SupplierStorefrontV2GetResponseType,
} from "@sellar-io/api-v2/types";
import { MinimumOrderPriceProgress } from "./MinimumOrderPriceProgress";
import { MinimumOrderQuantityProgress } from "./MinimumOrderQuantityProgress";
import { DeliveryDiscountDraftBasket } from "./DeliveryDiscountDraftBasket";
import { CaseSizeRuleStatus } from "./CaseSizeRuleStatus";
import { CaseSizeRuleType } from "../../../../../../stockList/useStockListOrderSummaryProps/useStockListOrderSummaryProps";
import { ORDER_BUYER } from "../../../../../../../constants/routes";
import { useNavigateToChild } from "../../../../../../../hooks/useParentNavigation";

type OrderItem = {
  quantity: number;
  containerType: string | null;
  volume: number | null;
  unit: string | null;
  packQuantity: number | null;
};

export const OrderRulesSummaryDraftBasket = ({
  priceTierOrderRules,
  minimumOrderPrice,
  supplierStorefront,
  orderTotal,
  currency,
  orderItemList,
  supplierUrlId,
  partiallySatisfiedCaseSizeRuleList,
  subtotalFreeDeliveryThreshold,
  subTotalApi,
}: {
  minimumOrderPrice?: number | null;
  priceTierOrderRules?: SupplierGetResponseType["CustomerZones"][number]["PriceTier"]["PriceTierOrderRules"];
  supplierStorefront: SupplierStorefrontV2GetResponseType | undefined;
  currency: SupplierGetResponseType["currency"];
  orderItemList: OrderItem[];
  orderTotal: number;
  supplierUrlId: string;
  partiallySatisfiedCaseSizeRuleList: CaseSizeRuleType[];
  subtotalFreeDeliveryThreshold: number;
  subTotalApi: number;
}) => {
  const navigateToChild = useNavigateToChild();

  return (
    <div className={"flex flex-col gap-2"}>
      {minimumOrderPrice ? (
        <MinimumOrderPriceProgress
          minimumOrderPrice={minimumOrderPrice}
          price={orderTotal}
          currency={currency}
          onClick={() =>
            navigateToChild(
              ORDER_BUYER.href({ supplierIdOrUrlId: supplierUrlId }),
            )
          }
        />
      ) : null}
      {priceTierOrderRules?.map((rule, i) => (
        <MinimumOrderQuantityProgress
          key={i}
          orderItemList={orderItemList}
          rule={rule}
          caseSizeRuleList={supplierStorefront?.CaseSizeRules.list ?? []}
          onClick={() =>
            navigateToChild(
              ORDER_BUYER.href({ supplierIdOrUrlId: supplierUrlId }),
            )
          }
        />
      ))}
      <CaseSizeRuleStatus
        caseSizeRules={partiallySatisfiedCaseSizeRuleList}
        enforceCaseSizeRules={!!supplierStorefront?.CaseSizeRules.enforced}
        onClick={() =>
          navigateToChild(
            ORDER_BUYER.href({ supplierIdOrUrlId: supplierUrlId }),
          )
        }
      />
      <DeliveryDiscountDraftBasket
        subtotalFreeDeliveryThreshold={subtotalFreeDeliveryThreshold}
        subtotal={subTotalApi}
        supplierUrlId={supplierUrlId}
      />
    </div>
  );
};
